/**
 *
 */
type Data = {
    type : string,
    value : string,
    filled ?: boolean
    proportion : number
};

/**
 *
 * @param type
 * @param value
 * @param outline
 * @param proportion
 * @constructor
 */
export default function Proportion ({ type, value, filled = false, proportion } : Data) {
    // init css
    let style = "rounded text-center text-decoration-none";
    style += filled ? ' p-2 text-white bg-' : ' text-';

    // set the text- and background-color
    if ("red" === type) {
        style += "danger";
    } else if ("yellow" === type) {
        style += "warning";
    } else {
        style += "success";
    }

    // render
    return (
        <div className={style}>
            <h4>{value}</h4>
            <p className={'h1 fw-bold'}>{Number(proportion).toFixed(2)}%</p>
        </div>
    );
}